import React from "react";
import { Cascader, CascaderProps } from "antd";
import styles from "./MaterialMatchCascader.module.scss";
import {
  PackagingMaterialMatchOption,
  useGetPackagingMaterialOptions,
} from "@/pages/packaging_materials/usePackagingMaterials";

function MaterialMatchCascader({
  dataset_id,
  onChange,
  loading,
}: {
  dataset_id?: number;
  onChange?: (_: any, selectedOptions: PackagingMaterialMatchOption[] | undefined) => void;
  loading?: boolean;
}) {
  const { data, isLoading } = useGetPackagingMaterialOptions();

  const displayRender: CascaderProps<PackagingMaterialMatchOption>["displayRender"] = (
    labels,
    selectedOptions = []
  ) =>
    labels.map((label, i) => {
      const option = selectedOptions[i];
      if (i === labels.length - 1) {
        return <span key={option.value}>{label}</span>;
      }
      return <span key={option.value}>{label}, </span>;
    });

  const getPath = (dataset_id: number, options?: PackagingMaterialMatchOption[]): string[] => {
    if (!options) {
      return [];
    }
    for (const option of options) {
      if (option.dataset_id === dataset_id) {
        return [option.value];
      }
      if (option.children) {
        const path = getPath(dataset_id, option.children);
        if (path.length) {
          return [option.value, ...path];
        }
      }
    }
    return [];
  };

  return (
    <div className={styles["cascader-container"]}>
      <Cascader
        options={data}
        onChange={onChange}
        placeholder="Please select"
        multiple={false}
        expandTrigger="hover"
        defaultValue={dataset_id ? getPath(dataset_id, data) : undefined}
        popupClassName={styles["popupClassName"]}
        className={styles["materialMatchCascader"]}
        displayRender={displayRender}
        loading={isLoading || loading}
      />
    </div>
  );
}

export default MaterialMatchCascader;
